import { Button, Icons } from '@commenda/kakashi';
import { TForkBannerProps } from '../types/types';

export const ForkBanner = ({
  version,
  sourceVersionLabel,
  discardConfig,
}: TForkBannerProps) => (
  <div className="flex items-start gap-md border-b border-stroke-3 bg-bg-secondary px-xl py-lg">
    <Icons.GitBranch01 className="mt-xxs size-4 shrink-0 text-text-tertiary" />
    <div className="flex-1">
      <p className="txt-extra-small-medium text-text-primary">
        Editing a new draft {version}
        {sourceVersionLabel ? `, copied from ${sourceVersionLabel}` : ''}
      </p>
      <p className="txt-extra-small-regular text-text-tertiary">
        The version that was live is untouched until you publish this one and
        mark it active.
      </p>
    </div>
    {discardConfig && (
      <Button
        variant="tertiary"
        size="sm"
        onClick={discardConfig.onDiscard}
        disabled={discardConfig.isDisabled}
        title={
          discardConfig.isDisabled
            ? 'Cannot discard while the agent is writing to this draft'
            : undefined
        }
      >
        Discard
      </Button>
    )}
  </div>
);
